<div class="eui-dialog__container"
    [class.eui-dialog__container--draggable]="data.draggable"
    [class.eui-dialog__container--no-padding]="data.hasNoBodyPadding"
    attr.data-e2e="{{ data.e2eAttr }}"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    [cdkDragDisabled]="!data.draggable">
    <div class="eui-dialog__wrapper">
        <div class="eui-dialog__header" [class.eui-dialog__header--handle-disabled]="!data.draggable" #euiDialogHeader cdkDragHandle>
            <ng-container *ngIf="!headerComponent">
                <div matDialogTitle class="eui-dialog__header-title">{{ data.title | translate }}</div>
                <button euiButton euiBasicButton euiRounded euiIconButton euiSizeS class="eui-dialog__header-close" (click)="closeDialog()" *ngIf="!data.disableClose">
                    <span euiIcon iconClass="eui-icon eui-icon-close-m"></span>
                </button>
            </ng-container>
        </div>
        <div class="eui-dialog__body" #euiDialogBody matDialogContent [style.min-height]="data.height" [style.max-height]="data.height">
            <ng-container *ngIf="!bodyComponent">
                <div class="eui-dialog__body-content-wrapper">
                    <span *ngIf="data.typeClass" class="eui-dialog__body-content-icon-container">
                        <span euiIcon iconClass="eui-icon eui-icon-ecl-error eui-dialog__body-content-icon" *ngIf="data.typeClass === 'danger'"></span>
                        <span euiIcon iconClass="eui-icon eui-icon-check eui-dialog__body-content-icon" *ngIf="data.typeClass === 'success'"></span>
                        <span euiIcon iconClass="eui-icon eui-icon-info eui-dialog__body-content-icon" *ngIf="data.typeClass === 'info'"></span>
                        <span euiIcon iconClass="eui-icon eui-icon-question eui-dialog__body-content-icon" *ngIf="data.typeClass === 'question'"></span>
                        <span euiIcon iconClass="eui-icon eui-icon-exclamation-triangle eui-dialog__body-content-icon" *ngIf="data.typeClass === 'warning'"></span>
                    </span>
                    <span innerHTML="{{ data.message | translate }}"></span>
                </div>
            </ng-container>
        </div>
        <div class="eui-dialog__footer" #euiDialogFooter matDialogActions *ngIf="data.hasFooter">
            <ng-container *ngIf="!footerComponent">
                <div class="eui-dialog__footer-actions-container" #euiDialogFooter>
                    <button *ngIf="!data.dismissButton.disabled" class="eui-dialog__footer-actions--dismiss" euiButton euiSecondary (click)="onClick(false)">
                        <span *ngIf="data.dismissButton.icon" euiIcon iconClass="eui-icon {{ data.dismissButton.icon }}"></span>
                        <span euiLabel>{{ data.dismissButton.label | translate }}</span>
                    </button>
                    <button *ngIf="!data.acceptButton.disabled" class="eui-dialog__footer-actions--accept" euiButton euiPrimary (click)="onClick(true)" cdkTrapFocus>
                        <span *ngIf="data.acceptButton.icon" euiIcon iconClass="eui-icon {{ data.acceptButton.icon }}"></span>
                        <span euiLabel>{{ data.acceptButton.label | translate }}</span>
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
